import { useContext } from "react";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { CardIcon } from "../../../../Layout/Common/CardIcon";

export const PayOnline = ({ handleOnCheck }) => {
  const { selectedPaymentType } = useContext(GlobalContext);
  return (
    <div className="payment-card-list shipPayment">
      <div className="shipping-method savedCards-details">
        <div className="shipping-method-info pay-option" data-group={1} data-type="payOnline" id="pay-account">
          <div>
            <input
              className="form-check-input"
              type="radio"
              name="paymentMethod"
              id="payOnline"
              value="PAYONLINE"
              onChange={() => handleOnCheck("PAYONLINE")}
              checked={selectedPaymentType == "PAYONLINE"}
            />
          </div>
          <label className="form-check-label" htmlFor="payOnline">
            <div className="full-width d-flex align-items-center" style={{ gap: "10px", minWidth: "50px" }}>
              <div className="pay-icon">
                <CardIcon cardType={"unknown"} />
              </div>
              <div>Pay Online</div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};
